/// <amd-module name="VSS/Redux/Modules/TTIMonitor/TTIMonitorContracts" />
export interface ITTIAwareState {
    ttiMonitorState: ITTIMonitorState;
}

export interface ITTIMonitorState {
    isPageInteractive: boolean;
}
